@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.checkboxContainer {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  background-color: transparent;
  position: relative;
  transition: background-color 0.3s ease;
  border: 1px solid rgba(201, 207, 219, 1);

  &.checked {
    background-color: v.$palette-orange-2;
    border: none;
  }

  .checkmark {
    display: none;
  }

  &.checked .checkmark {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 5px;
    height: 8px;
    border: solid v.$palette-white;
    border-radius: 1px;
    border-width: 0 2px 2px 0;
    transform: translate(-50%, -60%) rotate(45deg);
  }
}

.label {
  @include t.text(14px, 22px, 600);
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
